export namespace CoreEnum {
  export enum ENV {
    LOCAL = 'local',
    DEV = 'development',
    PROD = 'production'
  }

  export namespace STORAGE {
    export enum KEY {
      GENIE_JOIN_GLOBAL = 'GENIE_JOIN_GLOBAL',
      GENIE_WEBVIEW = 'GENIE_WEBVIEW'
    }

    export enum TYPE {
      STRING = 'string',
      NUMBER = 'number',
      BOOLEAN = 'boolean',
      OBJECT = 'object',
      ARRAY = 'array',
    }
  }

  export enum SPINNER {
    DEFAULT = 'DEFAULT',
    SPINNER_ERROR = 'SPINNER_ERROR'
  }

  export enum MODAL {
    CODE_REFRESH = 'CODE_REFRESH',
    MODAL_OPEN = 'MODAL_OPEN',
    PERSONAL_INFORMATION_AGREE = 'PERSONAL_INFORMATION_AGREE',
    SERVICE_AGREE = 'SERVICE_AGREE',
    SERVICE_AGREE_FOOTER = 'SERVICE_AGREE_FOOTER',
    GENIE_PERSONAL_INFORMATION = 'GENIE_PERSONAL_INFORMATION',
    MARKETING_INFORMATION_AGREE = 'MARKETING_INFORMATION_AGREE',
  }

  export enum MODAL_NAME {
    IPinConfirmModal = 'IPinConfirmModal',
    MobileConfirmModal = 'MobileConfirmModal'
  }

  export enum RESULT {
    DEFAULT = 'DEFAULT',
    CHILD = 'CHILD',
    SNS = 'SNS',
    CTN = 'CTN',
    CHANGE_PASSWORD = 'CHANGE_PASSWORD',
    EXIST_CTN = 'EXIST_CTN',
    TOKEN_VALID = 'TOKEN_VALID',
    RECANT = 'RECANT',
    CONSENT = 'CONSENT',
    TRANSFER = 'TRANSFER'
  }

  export enum WINDOW_OPTION {
    NICE = 'width=450, height=550, top=100, left=100, fullscreen=no,menubar=no,status=no,toolbar=no,titlebar=yes,location=no,scrollbar=no',
    EMAIL_NOT_COLLECT = 'width=400, height=202, top=100, left=100, fullscreen=no,menubar=no,status=no,toolbar=no,titlebar=yes,location=no,scrollbar=no'
  }

  export enum TIMER {
    SECOND = 1000,
    MINUTE = 60,
    HOUR = 60,
    AUTH_TIMER = 3 * TIMER.MINUTE * TIMER.SECOND,
    EMAIL_AUTH_TIMER = 3 * TIMER.MINUTE * TIMER.SECOND
  }
}
